import React, { useEffect, useState } from 'react'
import ListingForm from './listingForm'
import { Row, Col } from 'react-bootstrap'
import BackButton from '../../common/buttons/backButton'
import { useParams, Redirect } from 'react-router-dom'
import { getItemListing } from '../../../services/vendorService'
import {
  Item,
  Image,
  InstallmentOptions,
  Installment
} from '../../../models/Item'
import constants from '../../../config/constants'
import { toast } from 'react-toastify'
import { friendlyMessageFor } from '../../../utility/errorHelper'
import { imageArrayToStringArray } from '../../../utility/imageToStringUrl'
import {
  generateStraightPaymentObjects,
  installmentOptionsToInstallments,
  isStraight
} from '../../../utility/installmentHelper'
import { ParamTypes } from '../../../@types/global'

const VendorEditListing = () => {
  let { id } = useParams<ParamTypes>()
  const [itemListingDetails, setItemListingDetails] = useState<Item>()
  const [isItemExisting, setIsItemExisting] = useState(true)
  const [confirmStatus, setConfirmStatus] = useState(false)

  const handleConfirm = () => {
    if (!confirmStatus) {
      setConfirmStatus(true)
    }
  }

  useEffect(() => {
    if (id) {
      getItemListing(id)
        .then(doc => {
          if (doc) {
            if (Array.isArray(doc.installmentOptions)) {
              // For old data
              doc.installmentOptions = generateStraightPaymentObjects(1)
            } else if (doc.installmentOptions) {
              doc.installmentOptions =
                Object.entries(doc.installmentOptions).length === 0
                  ? generateStraightPaymentObjects(doc.variants.length)
                  : installmentOptionsToInstallments(
                      doc.installmentOptions as InstallmentOptions
                    )
            }

            doc.images = imageArrayToStringArray(doc.images as Image[])
            setItemListingDetails(doc)
          } else {
            toast.error(constants.alertError.itemNotFound, {
              autoClose: false
            })
            setIsItemExisting(false)
          }
        })
        .catch(error => {
          toast.error(friendlyMessageFor(error.code), { autoClose: false })
        })
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (!isItemExisting) return <Redirect to="/vendor/listings" />

  return (
    <>
      <>
        <Row>
          <Col className="pb-5" data-testid="backbutton">
            <h1 className="largeTitle">
              <div className="d-none d-sm-none d-md-none d-lg-inline">
                <BackButton
                  rootPaths={['/']}
                  size={35}
                  status={confirmStatus}
                  message="Save changes first!"
                />
              </div>
              Edit listing
            </h1>
          </Col>
        </Row>
        <Row>
          <Col xl="8" className="mx-auto">
            {itemListingDetails && (
              <ListingForm
                isEditing={true}
                handleConfirm={handleConfirm}
                initialValues={itemListingDetails}
                isInstallmentPayment={
                  isStraight(
                    itemListingDetails.installmentOptions as Installment[]
                  )
                    ? false
                    : true
                }
                id={id}
              />
            )}
          </Col>
        </Row>
      </>
    </>
  )
}

export default VendorEditListing
